export interface TableCellProps {
	children: React.ReactNode;
	colspan: number;
	colwidth: number[];
	rowspan: number;
}

const TableCell = (props: TableCellProps) => {
	return <td {...props} />;
};

export default TableCell;
